import { IAuthenticatedUser } from "../../Model/Authentication.model";
import * as AuthenticationActionTypes from "../UserAuthentication/UserAuthenticationActionTypes";
import { ActionWithPayload } from "@model/Store.model";

const USER_AUTHENTICATION_INITIAL_STATE: IAuthenticatedUser | null = null;

export const UserAuthenticationReducer = (
  state: IAuthenticatedUser | null = USER_AUTHENTICATION_INITIAL_STATE,
  action: ActionWithPayload<IAuthenticatedUser>
): IAuthenticatedUser | null => {
  switch (action.type) {
    case AuthenticationActionTypes.LOGIN_USER:
      return action.payload ?? null;
    case AuthenticationActionTypes.LOGOUT_USER:
      return null;
    default:
      return state;
  }
};
